<div [ngClass]="{'page-container': this.showHeader}">
  
  <!---------------------------->
  <!-- Header Filters -->
  <!---------------------------->
  
  @if (showHeader) {
    <div class="external-data-filters mt2 mb2">

      <!---------------------------->
      <!-- Route ID DDN-->
      <!---------------------------->
      <div class="external-data-filter route-id-filter">
        <div class="flex route-id-filter-content">
          <app-element-multi-select
            class="route-id-select"
            [cssClasses]="['w-100']"
            displayLabel="Route ID"
            placeholder="Select route IDs"
            [dataType]="multiSelectDataType"
            [options]="routeIDTypes"
            [searchable]="true"
            searchPlaceholder="Search route IDs"
            [selectedValues]="selectedRouteIDs"
            (selectedValuesChange)="onRouteIdsChanged($event)">
          </app-element-multi-select>
          <mat-icon class="info-icon ml1" [matTooltip]="'Select Route ID'">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Is Consumed DDN-->
      <!---------------------------->
      <div class="external-data-filter">
        <div class="filter-field-with-help">
          <app-element-select displayLabel="Is Consumed"
                              [defaultValue]="allOptions"
                              [options]="consumedStatuses"
                              (selectionChanged)="onSelectionChange($event, tableColumns.IsConsumed)"></app-element-select>
          <mat-icon class="info-icon ml1" [matTooltip]="'Select if consumed'">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Message ID Input-->
      <!---------------------------->
      
      <div class="external-data-filter">
        <div class="filter-field-with-help">
          <mat-form-field class="filter-input">
            <mat-label>Search by message ID</mat-label>
            <input matInput type="text" [formControl]="searchMessageFormControl"
                   [errorStateMatcher]="immediateErrorStateMatcher"
                   (input)="onInputChangedSearchMessages($event, tableColumns.MessageId)">
            <mat-error >Please enter at least 3 characters</mat-error>
          </mat-form-field>
          <mat-icon [matTooltip]="getInfoTooltip(InputName.MessageID)" class="info-icon ml1">help_outline</mat-icon>
        </div>
      </div>
      
      <!---------------------------->
      <!-- Correlation ID Input-->
      <!---------------------------->
      <div class="external-data-filter">
        <div class="filter-field-with-help">
          <mat-form-field class="filter-input">
            <mat-label>Search by correlation ID</mat-label>
            <input matInput type="text" [formControl]="searchMessageByCorrelationIdFormControl"
                   [errorStateMatcher]="immediateErrorStateMatcher"
                   (input)="onInputChangedSearchMessages($event, tableColumns.CorrelationId)">
            <mat-error >Please enter at least 3 characters</mat-error>
          </mat-form-field>
          <mat-icon [matTooltip]="getInfoTooltip(InputName.CorrelationID)" class="info-icon ml1">help_outline</mat-icon>
        </div>
      </div>

    </div>
  }

  <!---------------------------->
  <!-- Table -->
  <!---------------------------->

  @if (dataSource) {
    <div class="mat-elevation-z8 table-container">

    <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

      <ng-container [matColumnDef]="tableColumns.Id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.Id]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.DateTime">
        <th *matHeaderCellDef mat-header-cell class="w-10">Date</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.DateTime] | date: dateTimeFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MessageId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Message Id</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.MessageId]">
          {{row[tableColumns.MessageId] | truncateText: {sliceStart: 0, sliceEnd: 30, append: '...'} }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CorrelationId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Correlation Id</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.CorrelationId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RouteId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Route Id</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.RouteId]">
          <div class="flex justify-start items-baseline">
            <p class="m-r-20">
              {{row[tableColumns.RouteId] | truncateText: {sliceStart: 0, sliceEnd: 100, append: '...'} }}
            </p>
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Direction">
        <th *matHeaderCellDef mat-header-cell>Direction</th>
        <td *matCellDef="let row" mat-cell>
          @if (getMessageDirection(row[tableColumns.RouteId]); as direction) {
            <span class="flex items-center" [matTooltip]="direction">
              <mat-icon class="mr1">{{ getMessageDirectionIcon(row[tableColumns.RouteId]) }}</mat-icon>
              {{ direction }}
            </span>
          } @else {
            <span>-</span>
          }
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsConsumed">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Is Consumed</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">{{ row[tableColumns.IsConsumed] === "1" ? 'Y' : 'N' }}</span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Time">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Time (s)</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">{{ row[tableColumns.Time]/1000 | number: '.2-2' }}</span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TransactionType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Transaction Type</th>
        <td *matCellDef="let row" mat-cell>{{ row[tableColumns.TransactionType] }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Message">
        <th *matHeaderCellDef mat-header-cell>Request</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">
            <mat-icon class="mat-primary-color hand-cursor mr2" matTooltip="VIEW Message"
              (click)="openClickOpenMessageDialog($event, row, tableColumns.Message)">
              article
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MessageOutput">
        <th *matHeaderCellDef mat-header-cell>Response</th>
        <td *matCellDef="let row" mat-cell>
          <span class="center-align mr2">
            <mat-icon class="mat-primary-color hand-cursor mr2" matTooltip="VIEW Message"
              (click)="openClickOpenMessageDialog($event, row, tableColumns.MessageOutput)">
              article
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

     <mat-paginator #errorMessagesPaginator [length]="tableControl.length" [pageSize]="tableControl.pageSize"
                    [pageIndex]="0" [pageSizeOptions]="tableControl.pageSizeOptions" (page)="pageChanged($event)">
     </mat-paginator>
  </div>
  }
</div>
